import { Button, Card, Flex, Modal, Text } from '@Common/Components'
import { FC, getUrlParams } from '@Common/Services'
import moment from 'moment'
import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'

const getDateFromDayID = (dateId) => moment('2020-06-01').add(dateId, 'd')

export const DeleteAppointment = () => {
  const agencyCode = getUrlParams('agency')
  const appointmentId = getUrlParams('appointmentId')
  const [appointment, setAppointment] = useState()
  const [appDeleted, setAppDeleted] = useState(false)
  const navigate = useNavigate()
  const refModal = useRef()

  useEffect(() => {
    const getAppointment = async () => {
      /* const url = `${process.env.NODE_ENV === 'development' ? 'http://localhost:4000/newAppointment/' : '/newAppointment/'}?agency=${agencyCode}` */
      if (!appointmentId) return navigate('/newAppointment/?agency=' + agencyCode)
      const res = await FC.service('public').get('getAppointmentDetails', { query: { appointmentId } })
      if (!res || res?.state === 'cancelled') return navigate('/newAppointment/?agency=' + agencyCode)
      setAppointment(res)
    }
    getAppointment()
  }, [])

  const deleteAppointment = async () => {
    const res = await FC.service('public').get('deleteAppointment', { query: { appointmentId } })
    if (res) setAppDeleted(true)
  }

  if (!appointment) return null
  return (
    <Flex fw fh>
      <Card>
        <Flex>
          <Text title bold value='Cancellazione appuntamento' upCase size={22} style={{ marginBottom: 20 }} />
          {appDeleted
            ? <Text value='Appuntamento cancellato con successo.' />
            : (
              <>
                <Text value='Gentile cliente,' />
                <Text value={`abbiamo ricevuto la sua richiesta di prenotazione per un appuntamento presso la nostra agenzia
          in data ${moment(getDateFromDayID(appointment?.dayId)).format('DD/MM/YY')} dalle ${appointment?.fromDisplay} alle ${appointment?.toDisplay}`}
                />
                <Text value='Tuttavia, se ha cambiato idea e desidera cancellare la prenotazione, si prega di cliccare sul bottone qua sotto indicando la sua scelta.' />
                <Text value='Siamo a sua disposizione per qualsiasi domanda o chiarimento.' />
                <Text value='Grazie per aver scelto la nostra agenzia' />
                <Button label='Cancella appuntamento' icon='bin' style={{ marginTop: 20 }} onClick={() => refModal?.current?.show()} />
                <Modal ref={refModal} header='Sicuro di voler cancellare la prenotazione di questo appuntamento?' action={deleteAppointment} />
              </>)}
        </Flex>
      </Card>
    </Flex>
  )
}
